import {css} from "@emotion/css";
import React from "react";
import {GenderDeterminationSelection} from "./UserInformation";
import {convertUniversalDateToPersianDate} from "../../util/DateConvertor";
import {UserService} from "../../serverService/userService/UserService";
import {SnackbarHelper} from "../../util/SnackbarHelper";
import {useSnackbarDispatcher} from "../../context/SnackBarContext";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {useEffect} from "react";
import {useState} from "react";
import {
    RaikoBaseCardContainer,
    RaikoDatePicker, RaikoGridOneColumn, RaikoGridThreeColumn, RaikoSectionContainer,
    RaikoSimpleMultiLineInputOutlined,
    RaikoToggleOutlined,
    RaikoMobileInputOutlined,
    RaikoSimpleInputOutlined,
    RaikoNumberInputOutlined, RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoImageCropper
} from "@moeindal/base-raiko-panel-components";
import {useAuthState} from "../../context/AuthContext";
import {GroupsService} from "../../serverService/groups/GroupsService";
import {useParams} from "react-router-dom";
import CreatorInfo from "../../component/creatorInfo/CreatorInfo";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function UserBasicInformation({setFullName, userName, setUserName}) {
    const service = new UserService();
    const groupService = new GroupsService()
    const snackbar = new SnackbarHelper(useSnackbarDispatcher());
    const loading = new LoadingHelper(useLoadingDispatcher());
    const {fundID} = useAuthState()
    const {id: userID} = useParams()

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [gender, setGender] = useState(true);
    const [nationalCode, setNationalCode] = useState("");
    const [personalCode, setPersonalCode] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [telephone, setTelephone] = useState("");
    const [birthDate, setBirthDate] = useState("");
    const [education, setEducation] = useState("");
    const [job, setJob] = useState("");
    const [groupSelectedID, setGroupSelectedID] = useState(1);
    const [groupList, setGroupList] = useState([]);
    const [address, setAddress] = useState("");
    const [enabled, setEnabled] = useState(true);
    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");

    const [avatarId, setAvatarId] = useState(-1);
    const [avatarUrl, setAvatarUrl] = useState("");
    const [avatarFile, setAvatarFile] = useState();

    useEffect(() => {
        getUserInformationFromServer()
        getGroupListFromServer()
    }, [userID]);

    function getGroupListFromServer() {
        loading.show()
        groupService.getGroups(fundID, 0, 1000000).then(
            response => {
                setGroupList([])
                response.data.map((item) => {
                    setGroupList(prevState => [...prevState,
                        raikoCustomSelectItemGenerator(item.id, item.name)
                    ])

                })
            }
        ).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function getUserInformationFromServer() {
        loading.show()
        service.getUserInformation(fundID, userID).then(
            response => {
                setFirstName(response.firstName)
                setLastName(response.lastName)
                setUserName(response.username)
                setGender(response.gender)
                setNationalCode(response.nationalCode)
                setPersonalCode(response.nBirthCertificate)
                setPhoneNumber(response.phoneNumber)
                setTelephone(response.tellNumber)
                setBirthDate(convertUniversalDateToPersianDate(response.birthdate))
                setJob(response.jobTitle)
                setGroupSelectedID(response.groupShortInformationPresentationDto.id)
                setEducation(response.degreeEducation)
                setAddress(response.postalAddress)
                setEnabled(response.enabled)
                setCreatedBy(response.createdBy)
                setCreatedAt(convertUniversalDateToPersianDate(response.createdAt))

                if (response.firstName && response.lastName)
                    setFullName(`${response.firstName} ${response.lastName}`)
                else
                    setFullName(response.phoneNumber)

                setAvatarUrl(response.avatarUrl)
                setAvatarId(response.avatarId)

            }
        ).catch(reason => {
            snackbar.showServerErrorMessage(reason)
        }).finally(_ => {
            loading.hide()
        })
    }

    function handleUpdateUserInformation() {
        if (checkAllFields()) {
            loading.show()
            service.updateUserInformation(
                fundID,
                userID,
                avatarFile,
                avatarId,
                firstName,
                lastName,
                gender,
                nationalCode,
                personalCode,
                telephone,
                birthDate,
                education,
                phoneNumber,
                job,
                groupSelectedID,
                address,
                enabled
            ).then(response => {
                snackbar.showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
                snackbar.showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkAllFields() {
        let state = false
        let message = ""
        if (!firstName || firstName.trim().length === 0) {
            message = "لطفا  نام را وارد نمایید."
        } else if (!lastName || lastName.trim().length === 0) {
            message = "لطفا نام خانوادگی را وارد نمایید."
        } else if (parseInt(nationalCode) === 0) {
            message = "لطفا کد ملی را وارد نمایید."
        } else if (!gender || gender.length === 0) {
            message = "لطفا جنسیت را وارد نمایید."
        } else if (birthDate && birthDate.length === 0) {
            message = "لطفا تاریخ تولد را وارد نمایید."
        } else
            state = true
        if (message.length > 0)
            snackbar.showWarningMessage(message)
        return state
    }

    function updateAvatar(file, image) {
        setAvatarFile(file)
        setAvatarUrl(image)
    }

    return (
        <RaikoGridOneColumn className={css`gap: 1.5rem;`}>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateUserInformation}
                >
                    <RaikoGridOneColumn>
                        <RaikoImageCropper
                            avatarFile={avatarUrl}
                            updateAvatar={updateAvatar}
                        />
                        <RaikoGridThreeColumn>
                            <RaikoSimpleInputOutlined
                                labelText={"نام"}
                                setValue={setFirstName}
                                value={firstName}/>
                            <RaikoSimpleInputOutlined
                                labelText={"نام خانوادگی"}
                                setValue={setLastName}
                                value={lastName}/>
                            <RaikoCustomSelect
                                labelText={"جنسیت"}
                                setValue={setGender}
                                items={[
                                    raikoCustomSelectItemGenerator(true, GenderDeterminationSelection.MALE.name),
                                    raikoCustomSelectItemGenerator(false, GenderDeterminationSelection.FEMALE.name),
                                ]}
                                value={gender}
                            />
                            <RaikoNumberInputOutlined
                                maxLength={"10"}
                                value={nationalCode}
                                setValue={setNationalCode}
                                labelText={"کد ملی"}
                            />
                            <RaikoNumberInputOutlined
                                maxLength={"10"}
                                value={personalCode}
                                setValue={setPersonalCode}
                                labelText={"شماره شناسنامه"}
                            />
                            <RaikoMobileInputOutlined
                                labelText={"شماره همراه"}
                                setValue={setPhoneNumber}
                                value={phoneNumber}/>

                            <RaikoMobileInputOutlined
                                labelText={"شماره تلفن"}
                                setValue={setTelephone}
                                value={telephone}/>

                            <RaikoSimpleInputOutlined
                                labelText={"تحصیلات"}
                                setValue={setEducation}
                                value={education}/>

                            <RaikoSimpleInputOutlined
                                labelText={"شغل"}
                                setValue={setJob}
                                value={job}/>

                            <RaikoCustomSelect
                                labelText={"گروه"}
                                setValue={setGroupSelectedID}
                                items={groupList}
                                value={groupSelectedID}
                            />

                            <RaikoDatePicker
                                setDate={setBirthDate}
                                date={birthDate}
                                label={"تاریخ تولد"}
                            />

                            <RaikoToggleOutlined
                                labelText={"(فعال / غیر فعال)"}
                                setChecked={setEnabled}
                                checked={enabled}
                            />

                        </RaikoGridThreeColumn>

                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"آدرس"}
                            setValue={setAddress}
                            value={address}/>

                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <CreatorInfo createdBy={createdBy} createdAt={createdAt}/>
        </RaikoGridOneColumn>

    )
}